import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import styled from 'styled-components';
import Item from '../components/item';

const allItems = gql`
query getAllItems($offset: Int) {
  allItems(offset: $offset) {
    nextOffset
    totalCount
    items {
      imageUrl
      id
      ended
      descriptionData {
        condition
        description
      }
      location
      source
      highBidderId
      itemUrl
    }
  }
}
`;

const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const AllItems = () => (
  <ItemContainer>
    <Query query={allItems}>
      {({ loading, error, data }) => {
        if (loading) {
          return 'Loading...';
        }
        if (error) {
          return error.toString();
        }
        const items = data.allItems.items;
        return items.map(item => <Item item={item} />);
      }}
    </Query>
  </ItemContainer>
);

export default AllItems;



// WEBPACK FOOTER //
// ./src/all-items/index.js